module.exports = __webpack_public_path__ + "static/media/trash-car.7e134727.jpg";